var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLightbulb = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 18.125h-2.5a.625.625 0 1 0 0 1.25h2.5a.625.625 0 0 0 0-1.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.875 16.25h-3.75a.625.625 0 0 0 0 1.25h3.75a.625.625 0 1 0 0-1.25Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.43 2.449A6.214 6.214 0 0 0 10 .625a6.235 6.235 0 0 0-6.25 6.25c0 1.821.698 3.525 1.914 4.674l.17.16c.704.657 1.666 1.558 1.666 2.354V15a.625.625 0 0 0 .625.625h.938a.313.313 0 0 0 .312-.312v-4.578a.313.313 0 0 0-.2-.291 5.104 5.104 0 0 1-1.022-.561.625.625 0 1 1 .726-1.016c.289.205.845.508 1.121.508s.832-.304 1.122-.508a.625.625 0 0 1 .725 1.016 5.102 5.102 0 0 1-1.022.56.313.313 0 0 0-.2.291v4.579a.313.313 0 0 0 .313.312h.937A.625.625 0 0 0 12.5 15v-.937c0-.777.952-1.677 1.646-2.335l.192-.182c1.251-1.194 1.912-2.811 1.912-4.67a6.216 6.216 0 0 0-1.82-4.427Z",
    fill: "currentColor"
  })));
};
export { SvgLightbulb as ReactComponent };